<template>
  <footer class="footer-section">
    <v-container style="max-width: 1200px">
      <!-- CTA Banner -->
      <div class="cta-banner mb-16">
        <h2 class="cta-headline">{{ $t("footer.ctaHeadline") }}</h2>
        <p class="cta-sub">{{ $t("footer.ctaSub") }}</p>
        <v-btn
          color="white"
          depressed
          large
          rounded
          class="cta-btn mt-6"
          @click="dialog = true"
        >
          <span style="color: #1a1a2e; font-weight: 700">{{
            $t("footer.ctaBtn")
          }}</span>
        </v-btn>
      </div>

      <!-- Registration Dialog -->
      <v-dialog v-model="dialog" max-width="480" persistent>
        <v-card style="border-radius: 20px; padding: 8px">
          <v-card-title class="dialog-title pt-6 px-6 mb-4"
            >Сургуулиа бүртгүүлэх</v-card-title
          >
          <v-card-subtitle class="dialog-sub px-6 pb-4"
            >Мэдээллийг бөглөж бидэнтэй холбогдоорой.</v-card-subtitle
          >
          <v-card-text class="px-6">
            <v-text-field
              v-model="form.school"
              label="Сургуулийн нэр"
              outlined
              dense
              rounded
              class="mb-2"
              prepend-inner-icon="mdi-school-outline"
            />
            <v-text-field
              v-model="form.phone"
              label="Утасны дугаар"
              outlined
              dense
              rounded
              class="mb-2"
              prepend-inner-icon="mdi-phone-outline"
              type="tel"
            />
            <v-text-field
              v-model="form.email"
              label="И-мэйл хаяг"
              outlined
              dense
              rounded
              prepend-inner-icon="mdi-email-outline"
              type="email"
            />
          </v-card-text>
          <v-card-actions class="px-6 pb-6" style="gap: 10px">
            <v-btn
              text
              rounded
              class="flex-grow-1"
              @click="dialog = false"
              style="text-transform: none; color: #888"
              >Цуцлах</v-btn
            >
            <v-btn
              color="primary"
              depressed
              rounded
              class="flex-grow-1"
              @click="dialog = false"
              style="text-transform: none; font-weight: 700"
              >Илгээх</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Footer Links -->
      <v-row class="footer-links-row pb-10">
        <v-col cols="12" md="4" class="mb-8 mb-md-0">
          <div class="d-flex align-center mb-3">
            <v-icon color="white" size="22" class="mr-2"
              >mdi-lightning-bolt</v-icon
            >
            <span class="footer-logo">Daalgavar.MN</span>
          </div>
          <p class="footer-tagline" style="white-space: pre-line">
            {{ $t("footer.tagline") }}
          </p>
          <div class="social-icons mt-5 d-flex" style="gap: 10px">
            <div v-for="icon in socialIcons" :key="icon" class="social-icon">
              <v-icon size="18" color="#aaa">{{ icon }}</v-icon>
            </div>
          </div>
        </v-col>

        <v-col>
          <h1 class="footer-brand">Daalgavar.MN</h1>
        </v-col>
      </v-row>

      <div
        class="footer-bottom d-flex flex-column flex-sm-row align-center justify-space-between pt-6"
      >
        <p class="copyright">{{ $t("footer.copyright") }}</p>
        <div class="d-flex" style="gap: 20px">
          <a class="footer-link" href="#">{{ $t("footer.privacy") }}</a>
          <a class="footer-link" href="#">{{ $t("footer.terms") }}</a>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
import { h } from "vue";

export default {
  name: "FooterSection",
  data() {
    return {
      dialog: false,
      form: { school: "", phone: "", email: "" },
      socialIcons: [
        "mdi-twitter",
        "mdi-instagram",
        "mdi-facebook",
        "mdi-youtube",
      ],
    };
  },
  computed: {
    footerColumns() {
      const raw = this.$t("footer.columns");
      if (!Array.isArray(raw)) return [];
      return raw.map((col) => ({
        heading: String(col.heading || ""),
        links: Array.isArray(col.links) ? col.links.map(String) : [],
      }));
    },
  },
};
</script>

<style scoped>
.footer-section {
  background: #1a1a2e;
  padding: 80px 16px 32px;
  color: white;
}

.cta-banner {
  background: linear-gradient(5deg, #f38c90 0%, #f15b28 100%);
  border-radius: 28px;
  padding: 64px 48px;
  text-align: center;
}

@media (max-width: 600px) {
  .cta-banner {
    padding: 48px 28px;
  }
}

.cta-headline {
  font-size: 2.4rem;
  font-weight: 900;
  color: white;
  letter-spacing: -1px;
  line-height: 1.15;
  margin: 0;
}

.cta-sub {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.75);
  margin: 12px 0 0;
}

.cta-btn {
  text-transform: none;
  font-size: 0.95rem;
  height: 50px !important;
  letter-spacing: 0;
  padding: 0 32px !important;
}

.footer-logo {
  font-size: 1.2rem;
  font-weight: 800;
  color: white;
  letter-spacing: -0.5px;
}

.footer-tagline {
  font-size: 0.85rem;
  color: #888;
  line-height: 1.6;
  margin: 0;
}

.social-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.social-icon:hover {
  background: rgba(255, 255, 255, 0.12);
}

.footer-heading {
  font-size: 0.78rem;
  font-weight: 700;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 14px;
}

.footer-link-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link {
  font-size: 0.88rem;
  color: #888;
  text-decoration: none;
  transition: color 0.2s;
  font-weight: 400;
}

.footer-link:hover {
  color: white;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.copyright {
  font-size: 0.82rem;
  color: #666;
  margin: 0;
}

.dialog-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: #1a1a2e;
  letter-spacing: -0.3px;
}

.dialog-sub {
  font-size: 0.9rem;
  color: #888;
}

.footer-links-row {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 48px;
}

.footer-brand {
  font-size: 6rem;
  line-height: 0.8;
  color: #fff;
}

@media (max-width: 600px) {
  .footer-brand {
    font-size: 3rem !important;
  }
}
</style>
